/**
 * Club Tattoo — Featured Artists slider (vanilla JS, no dependencies)
 *
 * Contract with CSS (not written here, handled separately):
 *   - .pm-featured-artist_slider_track should be display:flex, flex-wrap:nowrap
 *   - Each .pm-featured-artist slide should be width:50% above 767px and
 *     width:100% at 767px and below, matching the breakpoint this script uses
 *   - Put a transition on transform on the track (e.g. transition: transform .3s ease)
 *     for the slide animation — this script only sets the transform value
 *
 * Behavior: loops by wrapping the index (next past the last slide jumps back
 * to the first, and vice versa) rather than a continuous infinite scroll.
 * Multiple sliders on one page are each initialized independently via
 * data-slider, so duplicate ids are never a problem.
 *
 * FIX (see inline note in render()): translateX(-X%) resolves against the
 * TRACK's own total width, not the viewport — so a fixed "100 / perView"
 * step is only correct when the track holds exactly perView slides. With
 * more slides, that percentage overshoots, and since it's multiplied by
 * index, the overshoot compounds on every click. Fixed by measuring the
 * actual rendered slide width + gap in pixels and translating by that,
 * which is exact regardless of slide count, gap, or breakpoint.
 */
(function () {
	var BREAKPOINT = '(max-width: 767px)';

	function itemsPerView() {
		return window.matchMedia(BREAKPOINT).matches ? 1 : 2;
	}

	function initSlider(root) {
		var track = root.querySelector('.pm-featured-artist_slider_track');
		if (!track) return;

		var slides = Array.prototype.slice.call(track.children);
		if (!slides.length) return;

		var prevBtn = root.querySelector('.previous');
		var nextBtn = root.querySelector('.next');
		var index = 0;

		function maxIndex() {
			return Math.max(slides.length - itemsPerView(), 0);
		}

		// Pixel width of one slide "step" (slide width + the gap after it),
		// read live from the rendered DOM so it always matches whatever the
		// CSS is currently doing (including responsive --slides-per-view
		// breakpoints) with no separate math to keep in sync.
		function slidePitchPx() {
			var trackStyles = getComputedStyle(track);
			var gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
			return slides[0].getBoundingClientRect().width + gap;
		}

		function render() {
			var upperBound = maxIndex();

			if (index > upperBound) index = upperBound;
			if (index < 0) index = 0;

			// Pixel-based offset — exact regardless of slide count/gap,
			// unlike a percentage step (which resolves against the track's
			// own total width and overshoots more slides you add).
			var offsetPx = index * slidePitchPx();
			track.style.transform = 'translateX(-' + offsetPx + 'px)';
		}

		function goNext() {
			index = index >= maxIndex() ? 0 : index + 1;
			render();
		}

		function goPrev() {
			index = index <= 0 ? maxIndex() : index - 1;
			render();
		}

		if (nextBtn) nextBtn.addEventListener('click', goNext);
		if (prevBtn) prevBtn.addEventListener('click', goPrev);
		window.addEventListener('resize', render);

		render();
	}

	function initAll() {
		document.querySelectorAll('[data-slider]').forEach(initSlider);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}
})();f